import { isBelowMinPrivilege, ROLES } from '../../utils/permissions_roles/roles';

let config;
export let hasFlowStatsConfig = false;

try {
  const loadedConfig = require('./' + process.env.REACT_APP_PROJECT_NAME + '-flowstats-config');
  config = loadedConfig.default ?? loadedConfig;
  hasFlowStatsConfig = true;
} catch (e) {
  config = {};
}

// Default privilege 3; projects can override it in their flowStats config.
export const canAccessStatisticsMode = (privilege) => hasFlowStatsConfig && (privilege ?? -1) >= (config.statisticsModeMinPrivilege ?? ROLES.SUPER_ADMIN);

export const canAccessStatisticsFeature = (privilege, feature, dataset) =>
  !isBelowMinPrivilege({ minPrivilege: dataset?.featureMinPrivileges?.[feature] ?? config.featureMinPrivileges?.[feature] }, privilege);

export default config;
